import { useMediaQuery } from '#/lib/browser/media-query';

type Breakpoint = 'gtPhone' | 'gtMobile' | 'gtTablet';

export function useBreakpoints(): Record<Breakpoint, boolean> {
	const gtPhone = useMediaQuery('(width >= 500px)');
	const gtMobile = useMediaQuery('(width >= 800px)');
	const gtTablet = useMediaQuery('(width >= 1300px)');
	return {
		gtPhone,
		gtMobile,
		gtTablet,
	};
}

/** Fine-tuned breakpoints for the shell layout */
export function useLayoutBreakpoints() {
	const rightNavVisible = useMediaQuery('(width >= 1100px)');
	const centerColumnOffset = useMediaQuery('(1100px <= width <= 1300px)');
	const leftNavMinimal = useMediaQuery('(width <= 1300px)');

	return {
		rightNavVisible,
		centerColumnOffset,
		leftNavMinimal,
	};
}
